
// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";

import { getMessaging, getToken, onMessage } from "firebase/messaging";
import * as api from "./api_function";




// import Cookies from 'js-cookie';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyCIl1tOXpjOil7hPF_hKAHdTcCsWQ-tyuk",
  authDomain: "spectra-ffa.firebaseapp.com",
  projectId: "spectra-ffa",
  storageBucket: "spectra-ffa.firebasestorage.app",
  messagingSenderId: "814923093255",
  appId: "1:814923093255:web:fa3f4b4276d8729dcfa1a2",
  measurementId: "G-KC4GPXYXX9",
  databaseURL: "https://spectra-ffa.firebaseio.com",
};

// Initialize Firebase
// initializeApp(firebaseConfig);
const firebaseApp = initializeApp(firebaseConfig);
const messaging = getMessaging(firebaseApp);

export const onMessageListener = () =>
  new Promise((resolve) => {
    onMessage(messaging, (payload) => {
      // console.log("payload", payload)
      resolve(payload);
    });
  });

// export const requestForToken = async () => {
//   const permission = await Notification.requestPermission();
//   console.log("permission", permission);
//   if(permission=="granted"){
//     const token =await getToken(messaging, { vapidKey: "BIZ-XgUuG5y_WMJyf1bNGUacmPr4oYr_pGwUfTidtp-P2QPC4ZSj98ZbV50F0okql28l7-tjJ-6hJqw81Cq9sGk" });
//     console.log("token",token)
//     sessionStorage.setItem('gmcToken', token);
//     // Cookies.set('gmcToken', token, { expires: 7 }); 
//   }else{
//     console.log("need to give permission for notification")
//   }
// };

// export const fetchFirebaseToken = async () => {
//   const token = sessionStorage.getItem('gmcToken');
//   if (!token) {
//     try {
//       const permission = await Notification.requestPermission();
//       if (permission === "granted") {
//         const newToken = await getToken(messaging, { vapidKey: "BIZ-XgUuG5y_WMJyf1bNGUacmPr4oYr_pGwUfTidtp-P2QPC4ZSj98ZbV50F0okql28l7-tjJ-6hJqw81Cq9sGk" });
//         console.log("FCM token generated:", newToken);
//         sessionStorage.setItem('gmcToken', newToken);
//         return newToken;
//       } else {
//         console.warn("Notification permission denied");
//       }
//     } catch (error) {
//       console.error("Error fetching new token:", error);
//     }
//   }
//   return token;
// };


// export const fetchFirebaseToken = async (maxRetries = 5) => {
//   // const isMobileDevice = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

//   // if (!isMobileDevice) {
//   //   console.log("FCM token generation skipped: not a mobile device.");
//   //   return null;
//   // }

//   let token = sessionStorage.getItem('gmcToken');
//   if (token && token !== 'undefined') {
//     console.log("✅ Existing token found in sessionStorage:", token);
//     await api.saveLog({ user_token_error: `✅ Existing token found in sessionStorage: ${token}`, user_name: sessionStorage.getItem('userName') });
//     return token;
//   }

//   const permission = await Notification.requestPermission();
//   if (permission !== "granted") {
//     console.warn("🔒 Notification permission denied");
//     await api.saveLog({ user_token_error: "🔒 Notification permission denied", user_name: sessionStorage.getItem('userName') });
//     return null;
//   }

//   const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
  

//   for (let attempt = 1; attempt <= maxRetries; attempt++) {
//     try {
//       token = await getToken(messaging, {
//         vapidKey: "BIZ-XgUuG5y_WMJyf1bNGUacmPr4oYr_pGwUfTidtp-P2QPC4ZSj98ZbV50F0okql28l7-tjJ-6hJqw81Cq9sGk",
//         serviceWorkerRegistration: registration,
//       });

//       if (!("Notification" in window)) {
//         await api.saveLog({ user_token_error: "⚠️ Notifications not supported in this browser", user_name: sessionStorage.getItem("userName") });
//         return null;
//       }

//       if (Notification.permission === 'denied') {
//         await api.saveLog({ user_token_error: "⚠️ Notifications are blocked by the user", user_name: sessionStorage.getItem("userName") });
//         return null;
//       }


//       if (token) {
//         console.log("✅ Token received on attempt", attempt, ":", token);
//         sessionStorage.setItem('gmcToken', token);
//         await api.saveLog({ user_token_error: `✅ Token received on attempt ${attempt}: ${token}`, user_name: sessionStorage.getItem('userName') });
//         return token;
//       } else {
//         console.warn(`⚠️ Attempt ${attempt} failed: token is undefined`);

//         await api.saveLog({ user_token_error: `⚠️ Attempt ${attempt} failed: token is undefined`, user_name: sessionStorage.getItem('userName') });

//       }
//     } catch (error) {
//       console.error(`❌ Error on attempt ${attempt}:`, error);
//       await api.saveLog({ user_token_error: JSON.stringify(`Error on attempt ${attempt}: ${error?.message || error}`), user_name: sessionStorage.getItem('userName') });
//     }

//     // Wait before retrying
//     await new Promise(res => setTimeout(res, 2000));
//   }

//   console.error("❌ Failed to fetch FCM token after all retries");
//   await api.saveLog({ user_token_error: "❌ Failed to fetch FCM token after all retries", user_name: sessionStorage.getItem('userName') });
//   return null;
// };

export const fetchFirebaseToken = async (maxRetries = 1) => {
  let token = sessionStorage.getItem('gmcToken');
  if (token && token !== 'undefined') {
    console.log("✅ Existing token found in sessionStorage:", token);
    await api.saveLog({ user_token_error: `✅ Existing token found in sessionStorage: ${token}`, user_name: sessionStorage.getItem('userName') });
    return token;
  }

  if (!("Notification" in window)) {
    await api.saveLog({ user_token_error: "⚠️ Notifications not supported in this browser", user_name: sessionStorage.getItem("userName") });
    return null;
  }

  if (Notification.permission === 'denied') {
    await api.saveLog({ user_token_error: "🔕 Notifications are blocked by the user (permission = denied)", user_name: sessionStorage.getItem("userName") });
    return null;
  }

  const permission = await Notification.requestPermission();
  if (permission !== "granted") {
    await api.saveLog({ user_token_error: "🔒 Notification permission not granted", user_name: sessionStorage.getItem('userName') });
    return null;
  }

  let registration = null;
  try {
    registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js');
    console.log("✅ Service worker registered");
    await api.saveLog({ user_token_error: "✅ Service worker registered", user_name: sessionStorage.getItem('userName') });
  } catch (err) {
    console.error("❌ Failed to register service worker:", err);
    await api.saveLog({ user_token_error: `❌ Failed to register service worker: ${err.message || err}`, user_name: sessionStorage.getItem('userName') });
    return null;
  }

  await navigator.serviceWorker.ready;

  if (!navigator.serviceWorker.ready) {
  console.warn("🟡 Service worker not yet active.");
  await api.saveLog({ user_token_error: "🟡 Service worker not yet active", user_name: sessionStorage.getItem('userName') });
}

  for (let attempt = 1; attempt <= maxRetries; attempt++) {
    try {
      token = await getToken(messaging, {
        vapidKey: "BIZ-XgUuG5y_WMJyf1bNGUacmPr4oYr_pGwUfTidtp-P2QPC4ZSj98ZbV50F0okql28l7-tjJ-6hJqw81Cq9sGk",
        serviceWorkerRegistration: registration,
      });

      if (token) {
        console.log("✅ Token received on attempt", attempt, ":", token);
        sessionStorage.setItem('gmcToken', token);
        await api.saveLog({ user_token_error: `✅ Token received on attempt ${attempt}: ${token}`, user_name: sessionStorage.getItem('userName') });
        return token;
      } else {
        console.warn(`⚠️ Attempt ${attempt} failed: token is undefined`);
        await api.saveLog({ user_token_error: `⚠️ Attempt ${attempt} failed: token is undefined`, user_name: sessionStorage.getItem('userName') });
      }
    } catch (error) {
      console.error(`❌ Error on attempt ${attempt}:`, error);
      await api.saveLog({ user_token_error: JSON.stringify(`Error on attempt ${attempt}: ${error?.message || error}`), user_name: sessionStorage.getItem('userName'), user_agent: navigator.userAgent, });
    }

    // Wait before retrying
    await new Promise(res => setTimeout(res, 2000));
  }

  console.error("❌ Failed to fetch FCM token after all retries");
  await api.saveLog({ user_token_error: "❌ Failed to fetch FCM token after all retries", user_name: sessionStorage.getItem('userName') });
  return null;
};

